import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/accordion.module.scss'
import text from 'styles/utility/text.module.scss'

type Props = {
  align?: 'left' | 'center' | 'right'
  handleExpand: () => void
  iconPath?: string
  isExpand: boolean
  label: string
  size?: 'small' | 'medium' | 'large'
  children: ReactNode
}

const Accordion: FC<Props> = (props) => {
  const { align = 'left', children, iconPath, isExpand, handleExpand, label, size = 'medium' } = props

  const sizeStyle = (() => {
    switch (size) {
      case 'small':
        return styles.accordion_small
      case 'medium':
        return styles.accordion_medium
      case 'large':
        return styles.accordion_large
      default:
        return styles.accordion_medium
    }
  })()

  const alignStyle = (() => {
    switch (align) {
      case 'left':
        return text.align_left
      case 'center':
        return text.align_center
      case 'right':
        return text.align_right
      default:
        return text.align_left
    }
  })()

  return (
    <div className={isExpand ? styles.open : ''}>
      <p className={`${styles.accordion} ${sizeStyle} ${alignStyle}`} onClick={handleExpand}>
        <span>{label}</span>
        {iconPath && <img className={styles.accordion__icon} src={iconPath} alt={label} />}
        <span className={styles.accordion__arrow} />
      </p>
      {children}
    </div>
  )
}

export default Accordion
